import { render, staticRenderFns } from "./ModalPageTarget.vue?vue&type=template&id=27ec3b61&"
import script from "./ModalPageTarget.vue?vue&type=script&lang=ts&"
export * from "./ModalPageTarget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports